import { Injectable } from '@angular/core';
import { ApiUrlHelper } from '../api-url-helper';
import { BehaviorSubject } from 'rxjs';
import { HttpClientHelper } from '../http-helper';
import { VideoTransFormer } from '../../_transformers/video.transformer';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class RandomVideosService {
    randomVideos = [];
    private _randomVideosService = new BehaviorSubject<any>([]);
    randomVideosSource$ = this._randomVideosService.asObservable();

    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
        private _videoTransFormer: VideoTransFormer,
    ) { }

    updateRandomVideos(cid) {
        this.getRandomVideosByCid(cid).subscribe(r => {
            this.randomVideos = [{
                cid: cid,
                lists: r
            }];
            this._randomVideosService.next(this.randomVideos);
        });
    }

    getWeekRenewVideoBydata(viewModel)
    {
        var apiURL = this._apiUrlHelper.urlBuilder('video-renew-videos-by-category',viewModel);
        return this._httpClientHelper.get(apiURL).pipe(map((list)=>{
            return list.map(item=>{
                return this._videoTransFormer.transformFromList(item);
            })
        }));
    }
    getRandomVideosByCid(cid) {
        const apiURL = this._apiUrlHelper.urlBuilder('video-random-videos-by-category', { cid, size: 6, set: 1 });

        return this._httpClientHelper.get(apiURL)
        .pipe(map((res) => {
                return res.map(list => {
                    if (list.randList) {
                        return {
                            cid: list.cid,
                            items: list.randList.map(item => {
                                return this._videoTransFormer.transformFromList(item);
                            }),
                        };
                    } else {
                        return {
                            cid: list.cid,
                            items: list.randAdultList.map(item => {
                                return this._videoTransFormer.transformFromList(item);
                            }),
                        };
                    }
                });
            }));
    }
}
